/** Keeps an item reference up to date with changes */
export class LiveItem {
    constructor(uuid, items, onChange) {
        this.item = items.findSureItem(uuid);
        onChange === null || onChange === void 0 ? void 0 : onChange(this.item);
        this.removeObserver = items.streamItems(this.item.content_type, ({ changed, inserted }) => {
            const matchingItem = [...changed, ...inserted].find((item) => {
                return item.uuid === uuid;
            });
            if (matchingItem) {
                this.item = matchingItem;
                onChange === null || onChange === void 0 ? void 0 : onChange(this.item);
            }
        });
    }
    deinit() {
        if (!this.removeObserver) {
            console.error('A LiveItem is attempting to be deinited more than once.');
        }
        else {
            this.removeObserver();
            this.removeObserver = undefined;
        }
    }
}
